module.exports = {
      id: "login-facebook-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#login-facebook",
      toString: function () {
        return this.url;
      }
    }